<template>
  <div class="page-cover">
    <div class="login-text">景尚旅业</div>
    <div class="app-text">景区团队数据</div>
    <div class="btn-wrap">
      <van-button @click.native="dengluhandler" style="cursor: pointer;" class="login-btn" type="primary" size="large">确认授权</van-button>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import '@vant/touch-emulator';
import Cookies from 'js-cookie'

export default {
  name: 'login.vue',
  data: () => {
    return {
    }
  },
  created () {
    const date1000122 =  (this.$route.query.date ==='undefined' || !this.$route.query.date) ? '' : this.$route.query.date
    Cookies.set('date1000122', date1000122, { expires: 14 })
    const userId1000122 = Cookies.get('userId1000122') ? Cookies.get('userId1000122') : ''
    if(userId1000122) {
      if(date1000122){
        window.location.href = "http://interview.uu1.com/performance/#/index?date=" + date1000122
      }else{
        this.$router.push('/index')
      }
    }else{
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww2c5c7a0ed1042294&redirect_uri=http://interview.uu1.com/performance/#/blank&response_type=code&scope=snsapi_base&state=#wechat_redirect`
    }
  },
  methods: {
    dengluhandler(){
      let uuid = uuidv4()
      uuid.replace('-', '')
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww2c5c7a0ed1042294&redirect_uri=http://interview.uu1.com/performance/#/blank&response_type=code&scope=snsapi_base&state=#wechat_redirect`
    },
  },
}
</script>

<style lang="less">

  .page-cover {
    width: 7.5rem;
    margin: 0 auto;
    .login-text{
      font-size: .48rem;
      margin-top: 1rem;
      margin-left: .44rem;
      font-weight: bold;
      color: #333;
    }
    .app-text{
      font-size: .36rem;
      color: #666;
      text-align: center;
      margin-top: 1.33rem;
    }
    .btn-wrap{
      width: 90%;
      margin-left: 5%;
      .login-btn{
        border-radius: .8rem;
      }
    }
  }

</style>

